import styled from "styled-components";

export const PhotoList = styled.div`
  
`

export const PhotoListImageWrapper = styled.div<{ aspectRatio: string }>`
  position: relative;
  width: 48%;
  aspect-ratio: 4 / 4;
  margin-bottom: ${({ theme }) => theme.rem(24)};
  overflow: hidden;
  border-radius: ${({ theme }) => theme.rem(8)};
  cursor: pointer;

  ${({ theme }) => theme.mediaQuery.xl(`
    width: 31%;
  `)}

  &:hover {
    img {
      transform: scale(1.05);
    }
  }

  img {
    transition: transform 0.2s ease-in-out;
    object-fit: cover;
    object-position: center;
  }
`

export const PhotoListImageTitle = styled.div`
  position: absolute;
  bottom: ${({ theme }) => theme.rem(16)};
  left: ${({ theme }) => theme.rem(16)};
`;

export const PhotoListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4%;

  ${({ theme }) => theme.mediaQuery.xl(`
    gap: 3%;  
  `)}
`